import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../auth/authSlice";
import { toast } from "react-toastify";
import { isSuperAdmin, isAdmin } from "../../utils/roleUtils";

const ProtectedRoute = ({
  children,
  requireSuperAdmin = false,
  requireAdmin = false,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const reduxSessionId = useSelector((state) => state.auth.sessionId);
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    const checkAuth = () => {
      // Check both Redux store and localStorage for sessionId
      const localSessionId = localStorage.getItem("sessionId");
      const hasValidSession = reduxSessionId || localSessionId;

      if (!hasValidSession) {
        // Clear any remaining auth data and redirect to login
        dispatch(logout());
        toast.error("Session expired. Please login again.");
        navigate("/login", { replace: true });
        return false;
      }

      // Check role-based access
      if (requireSuperAdmin && !isSuperAdmin(user)) {
        toast.error("Access denied. Super admin privileges required.");
        navigate("/home", { replace: true });
        return false;
      }

      if (requireAdmin && !isAdmin(user)) {
        toast.error("Access denied. Admin privileges required.");
        navigate("/home", { replace: true });
        return false;
      }

      // If we have a sessionId in localStorage but not in Redux,
      // it means the page was refreshed - let the auth slice handle it
      return true;
    };

    checkAuth();
  }, [
    reduxSessionId,
    navigate,
    dispatch,
    requireSuperAdmin,
    requireAdmin,
    user,
  ]);

  // Check authentication before rendering
  const localSessionId = localStorage.getItem("sessionId");
  const hasValidSession = reduxSessionId || localSessionId;

  if (!hasValidSession) {
    return null; // Don't render anything while redirecting
  }

  // Check role-based access before rendering
  if (requireSuperAdmin && !isSuperAdmin(user)) {
    return null;
  }

  if (requireAdmin && !isAdmin(user)) {
    return null;
  }

  return children;
};

export default ProtectedRoute;
